export { renderSlider_unstable as renderSlider } from '@fluentui/react-slider';
